module.exports = {"title":"코스 선택","invalidUserInfo":"사용자 정보가 올바르지 않습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/accountclubs.json
// module id = CGC7
// module chunks = 2